const moment = require('moment');
require('moment-precise-range-plugin');
$ = jQuery;

class SeniorityCalculator {
    constructor(el) {
        if(!this.set(el)) return;
        this.init();
    }

    set(el) {
        if(!el) return false;
        this.root = el;
        this.periodsWrapper = this.root.querySelector('[data-seniority-calculator-periods]');
        this.periods = this.root.querySelectorAll('[data-seniority-calculator-period]');
        this.addButton = this.root.querySelector('[data-seniority-calculator-add]');
        this.submit = this.root.querySelector('[data-seniority-calculator-calculate]');
        this.results = this.root.querySelector('[data-seniority-calculator-result]');
        this.resultsText = this.root.querySelector('[data-seniority-calculator-result-text]');
        this.vacationCheckboxes = this.root.querySelectorAll('.seniority-calculator__vacationCheck');
        this.download = this.root.querySelector('[data-seniority-calculator-download]');

        this.days = 0;
        this.daysString = '';
        this.dates = [];
        return true;
    }

    init() {
        this.setAddButton();
        this.setSubmit();
        this.setDownload();
        this.setVacationCheckboxes();
    }

    setAddButton() {
        if(!this.addButton) return;
        this.onAddButton = this.onAdd.bind(this);
        this.addButton.addEventListener('click', event => this.onAddButton(event));
    }

    setSubmit() {
        if(!this.submit) return;
        this.onSubmitClick = this.onSubmit.bind(this);
        this.submit.addEventListener('click', event => this.onSubmitClick(event));
    }

    setRemoveButton(button) {
        this.onRemoveButton = this.onRemove.bind(this);
        button.addEventListener('click', event => this.onRemove(event));
    }

    setDownload() {
        if(!this.download) return;
        this.onDownload = this.onDownloadClick.bind(this);
        this.download.addEventListener('click', event => this.onDownloadClick(event));
    }

    setVacationCheckboxes() {
        if (!this.vacationCheckboxes) return;
        this.vacationCheckboxes.forEach(item => this.setVacationCheckbox(item));
    }

    setVacationCheckbox(checkbox) {
        this.onVacation = this.onVacationCheck.bind(this);
        checkbox.addEventListener('click', this.onVacation);
    }

    onAdd(event) {
        const last = this.periodsWrapper.lastElementChild;
        const cloned = last.cloneNode(true);
        const fromInput = cloned.querySelector('[data-seniority-calculator-period-from]');
        const toInput = cloned.querySelector('[data-seniority-calculator-period-to]');
        const buttonRemove = cloned.querySelector('[data-seniority-calculator-period-remove]');
        const errEl = cloned.querySelector('.seniority-calculator__error');
        const vacationCheckbox = cloned.querySelector('.seniority-calculator__vacationCheck');

        fromInput.value = toInput.value;
        errEl.innerHTML = '';
        this.periodsWrapper.appendChild(cloned);

        this.setRemoveButton(buttonRemove);
        this.setVacationCheckbox(vacationCheckbox);
        this.checkPeriods();
    }

    onRemove(event) {
        const { currentTarget } = event;
        const period = currentTarget.closest('[data-seniority-calculator-period]');

        if(!period) return;
        period.remove();
        this.checkPeriods();
    }

    onVacationCheck(event) {
        const { currentTarget } = event;
        const { checked, parentNode } = currentTarget;
        const vacationSibling = parentNode.nextElementSibling;

        if (checked) {
            currentTarget.classList.add('checked');
            if (vacationSibling) vacationSibling.classList.remove('d-none');
        } else {
            currentTarget.classList.remove('checked');
            if (vacationSibling) vacationSibling.classList.add('d-none');
        }
    }

    onDownloadClick(event) {
        const formData = new FormData();
        formData.append('dates', JSON.stringify(this.dates));
        formData.append('overallDays', this.daysString);
        
        $.ajax({
            type: 'POST',
            url: `${ajax.siteUrl}/wp-json/seniority/v1/summary`,
            data: formData,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            beforeSend: function () {},
            success: function (response) {
                const { data } = response;
                const { pdf } = data;

                if(pdf !== '') {
                    const link = document.createElement('a');
                    link.href = `data:application/pdf;base64,${pdf}`;
                    link.download = 'staz-pracy.pdf';
                    link.dispatchEvent(new MouseEvent('click'));
                }
            },
        });
    }

    onSubmit(event) {
        event.preventDefault();
        if (!this.periods) return;

        this.days = 0;
        this.resetSummary();
        this.resetInputs();
        const errors = [];
        const dates = [];
        let vacationDaysCount = 0; 

        this.periods.forEach(period => {
            const isVacation = period.querySelector('[data-seniority-calculator-is-vacation]');
            const vacationDays = period.querySelector('[data-seniority-calculator-vacation-days]');
            const company = period.querySelector('[data-seniority-calculator-period-company]');
            const from = period.querySelector('[data-seniority-calculator-period-from]');
            const to = period.querySelector('[data-seniority-calculator-period-to]');
            const from_str = from.valueAsDate;
            const to_str = to.valueAsDate;
            const isVacationChecked = isVacation.checked;
            const vacationDaysNumber = (isVacationChecked && vacationDays.value !== '') ? vacationDays.valueAsNumber : 0;

            if (from_str === '') errors.push({
                periodEl: period,
                fromEl: from,
                toEl: to,
                type: 'from_empty',
                message: 'Nie wybrano daty',
            });

            if (to_str === '') errors.push({
                periodEl: period,
                fromEl: from,
                toEl: to,
                type: 'to_empty',
                message: 'Nie wybrano daty',
            });

            if (this.checkErrors(errors)) return;

            const dateFromFormat = new Date(from_str.getTime());
            const dateToFormat = new Date(to_str.getTime());
            dateToFormat.setDate(dateToFormat.getDate() + 1);

            if (vacationDaysNumber >= 0) dateToFormat.setDate(dateToFormat.getDate() - vacationDaysNumber);

            const date_from = dateFromFormat.getTime();
            const date_to = dateToFormat.getTime();

            if (date_from >= date_to) errors.push({
                periodEl: period,
                fromEl: from,
                toEl: to,
                type: 'from_greater',
                message: 'Data rozpoczęcia jest większa niz data zakończenia',
            });

            if (from_str === '' || to_str === '') {
                errors.push({
                    periodEl: period,
                    fromEl: from,
                    toEl: to,
                    type: 'empty_dates',
                    message: 'Proszę poprawnie wpisać daty',
                });
            }

            const daysTime = date_to - date_from;
            const daysCount = daysTime / (1000 * 3600 * 24);
            const daysString = this.getFormatedStringFromDays(daysCount);

            const diff = this.dateDiffInYearsMonthsDays(date_from, date_to);
            const humanDate = this.getFormatedStringFromDays(diff);

            dates.push({
                company: company.value,
                vacation: (isVacationChecked) ? vacationDaysNumber : 0,
                from: from_str,
                to: to_str,
                fromTimestamp: date_from,
                toTimestamp: date_to,
                daysCount,
                daysString,
                from_str: from.value,
                to_str: to.value,
                human_date: humanDate,
                diff_date: diff
            });
        });

        this.dates = dates;
        if (this.checkErrors(errors)) return;

        const days = this.getDaysCount(dates);
        this.days = days;

        const totalDays = this.getTotalYearsMonthDays(this.dates);
        this.daysString = this.getFormatedStringFromDays(totalDays);

        this.renderSummary(totalDays);
    }

    checkPeriods() {
        this.periods = this.root.querySelectorAll('[data-seniority-calculator-period]');

        this.periods.forEach((period, index) => {
            // const labelEl = period.querySelector('[data-seniority-calculator-period-label]');
            const company = period.querySelector('[data-seniority-calculator-period-company]');
            const fromInput = period.querySelector('[data-seniority-calculator-period-from]');
            const toInput = period.querySelector('[data-seniority-calculator-period-to]');
            const vacationCheckbox = period.querySelector('[data-seniority-calculator-is-vacation]');
            const vacationInput = period.querySelector('[data-seniority-calculator-vacation-days]');
    
            company.value = `Pracodawca ${index + 1}`;
            period.setAttribute('data-seniority-calculator-period', index + 1);
            fromInput.setAttribute('name', `seniority_calc[${index + 1}][date_from]`);
            toInput.setAttribute('name', `seniority_calc[${index + 1}][date_from]`);
            vacationInput.setAttribute('name', `seniority_calc[${index + 1}][vacation_days]`);
            vacationCheckbox.setAttribute('name', `seniority_calc[${index + 1}][is_vacation]`);
        });
    }

    checkErrors(errors) {
        let hasErrors = false;

        if (errors.length) {
            errors.forEach(err => {
                const { periodEl, fromEl, toEl, type, message } = err;
                const errEl = periodEl.querySelector('.seniority-calculator__error');
                
                if (type === 'from_empty') {
                    fromEl.classList.add('error');
                    errEl.innerHTML = message;
                    hasErrors = true;
                }

                if (type === 'to_empty') {
                    toEl.classList.add('error');
                    errEl.innerHTML = message;
                    hasErrors = true;
                }
            
                if (type === 'from_greater') {
                    fromEl.classList.add('error');
                    errEl.innerHTML = message;
                    hasErrors = true;
                }
                
                if (type === 'empty_dates') errEl.innerHTML = message;
            })
        }

        return hasErrors;
    }

    resetSummary() {
        if (!this.results) return;
        this.results.classList.add('d-none');
        this.resultsText.innerHTML = '';
    }

    resetInputs() {
        this.periods = this.root.querySelectorAll('[data-seniority-calculator-period]');
        if (!this.periods) return;

        this.periods.forEach(period => {
            const inputs = period.querySelectorAll('[data-seniority-calculator-period-input]');
            const errEl = period.querySelector('.seniority-calculator__error');

            inputs.forEach(input => {
                input.classList.remove('error');
            });

            errEl.innerHTML = '';
        });
    }

    getDaysCount(dates, vacation = null) {
        let days = 0;
        let prevDate = null;

        dates.forEach((date, index) => {
            const { fromTimestamp, toTimestamp } = date;

            if (prevDate) {
                const prevFromTimestamp = prevDate.fromTimestamp;
                const prevToTimestamp = prevDate.toTimestamp;

                const daysTime = toTimestamp - fromTimestamp;
                let daysCount = daysTime / (1000 * 3600 * 24);

                if (fromTimestamp < prevToTimestamp) {
                    const prevDiff = prevToTimestamp - fromTimestamp;
                    let prevDaysDiff = prevDiff / (1000 * 3600 * 24);
                    daysCount -= prevDaysDiff;
                }

                days += daysCount;
            } else {
                const daysTime = toTimestamp - fromTimestamp;
                let daysCount = daysTime / (1000 * 3600 * 24);
                days += daysCount;
            }
            
            prevDate = date;
        })

        if (vacation) {
            days = days - vacation;
        }

        return days;
    }

    getTotalYearsMonthDays(periods) {
        let totalYears = 0;
        let totalMonths = 0;
        let totalDays = 0;
        
        periods.forEach(period => {
            const { fromTimestamp, toTimestamp } = period;
            const from = moment(fromTimestamp);
            const to = moment(toTimestamp);

            const duration = moment.duration(to.diff(from));
            const diff = moment.preciseDiff(from, to, true);

            totalYears += diff.years;
            totalMonths += diff.months;
            totalDays += diff.days;
            
            
            while (totalMonths >= 12) {
                totalYears++;
                totalMonths -= 12;
            }
            
            while (totalDays >= 30) {
                totalMonths++;
                totalDays -= 30;
            }
        })

        return {
            years: totalYears,
            months: totalMonths,
            days: totalDays,
        }
    }

    dateDiffInYearsMonthsDays(date1, date2) {
        const starts = moment(date2);
        const ends   = moment(date1);

        const duration = moment.duration(ends.diff(starts));
        const diff = moment.preciseDiff(starts, ends, true); 
        const diffHuman = moment.preciseDiff(starts, ends);

        const { years, months, days } = diff;

        return {
            years,
            months,
            days
        }
      }

    getFormatedStringFromDays(data) {
        const { years, months, days } = data;
    
        const yearsDisplay = this.getYearsText(years);
        const monthsDisplay = this.getMonthsText(months);
        const daysDisplay = this.getDaysText(days);
        const texts = [];

        if (yearsDisplay !== '') texts.push(yearsDisplay);
        if (monthsDisplay !== '') texts.push(monthsDisplay);
        if (daysDisplay !== '') texts.push(daysDisplay);

        return texts.join(', '); 
    }

    getDaysText(days) {
        if (days === 1) return `${days} dzień`;
        if (days > 0) return `${days} dni`;
        return '';
    }

    getMonthsText(months) {
        if (months === 1) return `${months} miesiąc`;
        if (months > 0 && months < 5) return `${months} miesiące`;
        if (months >= 5 && months <= 12) return `${months} miesięcy`;
        return '';
    }

    getYearsText(years) { 
        const lastDigit = years % 10;

        if (lastDigit === 1) return `${years} rok`;
        if (lastDigit > 1 && lastDigit < 5) return `${years} lata`;
        if (lastDigit >= 5 && lastDigit <= 9) return `${years} lat`;
        if (lastDigit === 0 && years >= 10) return `${years} lat`;
        return '';
    }

    renderSummary(data) {
        const formattedDays = this.getFormatedStringFromDays(data);

        this.results.classList.remove('d-none');
        this.resultsText.innerHTML = formattedDays;
    }
}

export default function Calculator() {
    const sections = document.querySelectorAll('[data-seniority-calculator]');
    if (!sections) return;

    sections.forEach(section => {
        new SeniorityCalculator(section);
    })
}